import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "timeline-add-section-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M12.75 3a.75.75 0 0 0-1.5 0v4.25H7a4.75 4.75 0 0 0 0 9.5h4.25V21a.75.75 0 0 0 1.5 0v-4.25H17a4.75 4.75 0 1 0 0-9.5h-4.25V3ZM12 8.75H7a3.25 3.25 0 0 0 0 6.5h10a3.25 3.25 0 0 0 0-6.5h-5Z"
    }, null, -1)
  ])))
}
export default { render: render }